import { Box, Typography } from "@mui/material";
import { PointsActionUserTransferCompleted } from "@t3/shared";
import { BaseTransactionCard } from "./BaseTransactionCard";
import { DateDisplay, PointsBadge } from "./TransactionCardComponents";

interface UserTransferCardProps {
  action: PointsActionUserTransferCompleted;
  createdAt: string;
}

export const UserTransferCard = ({
  action,
  createdAt,
}: UserTransferCardProps) => {
  const typeMeta = action.typeMeta;
  // Fallback for old data that might not have points
  const pointsValue = typeMeta.points ?? 0;
  const isReceiving = pointsValue > 0;
  const pointsDisplay = typeMeta.points ?? "—";

  return (
    <BaseTransactionCard minHeight={120}>
      <Box display="flex" flexDirection="column" height="100%">
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="flex-start"
          mb="auto"
        >
          <Box>
            <Typography
              variant="h5"
              sx={{
                fontWeight: 600,
                color: "text.primary",
                mb: 0.5,
              }}
            >
              {isReceiving ? "Points Received" : "Points Sent"}
            </Typography>
            {typeMeta.reason && (
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{
                  fontSize: "0.875rem",
                  fontStyle: "italic",
                }}
              >
                {typeMeta.reason}
              </Typography>
            )}
          </Box>
          <PointsBadge
            points={pointsDisplay}
            label=""
            variant={isReceiving ? "transferred-in" : "transferred-out"}
          />
        </Box>
        <Box mt={1.5}>
          <DateDisplay date={createdAt} />
        </Box>
      </Box>
    </BaseTransactionCard>
  );
};
